import {validateLength} from "../functions/length";
import {smallAlphabetNumber} from "../functions/small-alphabet-number";
import {createValidator} from "../validate";

export const usernameValidator = createValidator(validateLength(1, 45), smallAlphabetNumber());
